export default "__VITE_PUBLIC_ASSET__4d9e49ee__"